/**
 * Expandable catalog system for managing dynamic options in forms.
 * Provides versioned, user-customizable catalogs with export/import capabilities.
 */

export interface CatalogOption {
  id: string;
  label: string;
  description?: string;
  isUserDefined: boolean; // true = added by user, false = default
  isActive?: boolean; // false = disabled, kept for existing references
  createdAt: string;
}

export interface ExpandableCatalog {
  id: string;
  label: string;
  description: string;
  behavior: 'strict' | 'suggestions';
  isUserEditable: boolean;
  options: CatalogOption[];
  version: string;
  isUserModified: boolean; // true if user has added/removed/changed any options
  createdAt: string;
  updatedAt: string;
}

export interface CatalogImportResult {
  success: boolean;
  catalogsImported: string[];
  errors?: string[];
  warnings?: string[];
}

// Built-in catalog identifiers
export const CATALOG_IDS = {
  TOXIC_GASES: 'toxic_gases',
  PLANT_TYPES: 'plant_types',
  PLANT_LOCATIONS: 'plant_locations',
  COMPONENT_CATEGORIES: 'component_categories',
  THRESHOLD_TYPES: 'threshold_types',
  THRESHOLD_UNITS: 'threshold_units',
  THRESHOLD_ACTIONS: 'threshold_actions',
} as const;
